import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { submit, isSubmitting, touch, isValid } from 'redux-form';

import Button from 'components/common/Button';

import SignUpCompanyForm from './SignUpCompanyForm';

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    minHeight: 376,
    paddingBottom: 58,
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      width: 576,
    },
  },
  form: {
    padding: '0 16px 16px',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      padding: '0 53px 36px',
    },
  },
  grid: {
    display: 'flex',
  },
  footer: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    padding: '8px 16px',
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    [theme.breakpoints.up('sm')]: {
      padding: '8px 63px',
    },
    '& $grid': {
      justifyContent: 'space-between',
    },
  },
});

const SignUpCompany = ({
  form, actions, submitting, onSubmitSuccess, initialValues, classes,
}) => (
  <Paper
    className={classes.root}
    square
    elevation={5}
  >
    <SignUpCompanyForm
      className={classes.form}
      form={form}
      initialValues={initialValues}
      onSubmitSuccess={onSubmitSuccess}
    />
    <div className={classes.footer}>
      <Grid
        className={classes.grid}
        container
        justify="space-between"
        alignItems="center"
        spacing={16}
      >
        <Grid item>
          <Typography variant="caption">
            STEP 4/4
          </Typography>
        </Grid>
        <Grid item>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            spacing={16}
          >
            <Grid item>
              <Button
                onClick={() => actions.submit(form)}
                variant="raised"
                color="primary"
                size="lg"
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  </Paper>
);

SignUpCompany.propTypes = {
  form: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  onSubmitSuccess: PropTypes.func,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
    touch: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
  }).isRequired,
};

SignUpCompany.defaultProps = {
  form: 'signUpForm',
  onSubmitSuccess: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
  valid: isValid(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit, touch }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(SignUpCompany),
);



// WEBPACK FOOTER //
// ./src/components/account/SignUpCompany/SignUpCompany.js